import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronUp, Filter, RotateCcw } from "feather-icons-react";
import Table from "../../../core/pagination/datatable";
import { useEffect } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { setheadertoggle } from "../../../redux/toggle";

import {
  exportExcel,
  exportPDF,
  HandlePrint,
  renderTooltip,
} from "../../../redux/helper";
import {
  fetchUnit,
  fetchProduct,
  fetchTax,
  fetchSettings,
  fetchCustomer,
} from "../../../redux/userSetting";
import { DatePicker, Select, Tabs } from "antd";
import { getCategoryWiseReport, getConsolidatedReportSectionwise, getitemWiseSalesReport } from "../../../services/ReportApiService";
import {
  DatatablePagingParameter,
  Filterclass,
} from "../../../core/json/DatatablePagingParameters";
import dayjs from "dayjs";
import { useMemo } from "react";
import LoadingUtils from "../../../core/utils/LoadingUtils";
import {
  exportMasterExcel,
  exportMasterPDF,
  printMasterReport,
} from "../../../core/utils/MasterReportUtils";

const CategoryReport = () => {
  const [searchText, setSearchText] = useState("");
  const [reportData, setreportData] = useState([]);
  const [loading, setloading] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const { branch } = useSelector((state) => state.branchlist);
  const dispatch = useDispatch();
   const [decimalpoints, setDecimalPoints] = useState(2);
   const [pageSize, setPageSize] = useState(10);
    const {settingList} = useSelector((state) => state.usersetting);
  const [activeTab, setActiveTab] = useState("1");
  const { TabPane } = Tabs;

  const { togglehead } = useSelector((state) => state.headerToggle);
  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);

    setToDate(null); // reset to date when from date changes
  };
  const handleToDateChange = (date) => {
    setToDate(date);
  };
  useEffect(() => {
    //setreportData(salesReportConsol);
    handleReportList();
     dispatch(fetchUnit());
        dispatch(fetchProduct(branch));
        dispatch(fetchTax());
        dispatch(fetchSettings(branch));
        const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
        const currfmt = match ? match[0]?.length - 1 : 0;
        setDecimalPoints(currfmt);
  }, []);
  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  const handleReportList = async () => {
    setloading(true);
    const DatatablePagingParameters = new DatatablePagingParameter();
    const formattedfromDate = dayjs(fromDate)
      .startOf("day")
      .format("YYYY-MM-DD");
    const formattedtoDate = dayjs(toDate).endOf("day").format("YYYY-MM-DD");
    const Filters = new Filterclass();
    DatatablePagingParameters.PageSize = -1;
    const branchCopy = { ...branch }; // Creates a shallow copy
    delete branchCopy.guid;
    Filters.Branch = branchCopy;
    Filters.FromDate = formattedfromDate;
    Filters.ToDate = formattedtoDate;
    Filters.PaymentType = "";
    Filters.Waiter = "";
    Filters.Counter = "";
    Filters.Section = "";
    try {
      const response = await getCategoryWiseReport({
        DatatablePagingParameters,
        Filters,
      });
console.log(response.data.itemWiseSalesReportDetail,"categorywise")
      const dataArray = [response.data];
      console.log("object",dataArray)
      setloading(false);
      if (Array.isArray(dataArray)) {
       
        const data = dataArray?.map((item) => {
            return (item.itemWiseSalesReportDetail || [])
              .filter((e) => !e.cancelled && !e.refund)
              .filter((e) => e?.paymentType !== 5)
              .map((e) => {
                return {
                  branch: e.branch?.name,
                  category: e.product?.category?.name, // Updated from section to category
                  netTotal: e.total,
                };
              });
          });
          
       console.log("categorrrrrrrrrryyyy",data)
  
        setreportData(data[0]);
      } else {
        setreportData([]);
      }
    } catch (error) {
      setloading(false);
      console.log(error?.response?.data?.Message || "something went wrong");
      setreportData([]);
    }
   
  };

  // const { branches, categories, tableData, summaryData, branchGrandTotal } = useMemo(() => {
  //   if (!reportData || reportData.length === 0) return { branches: [], categories: [], tableData: [], summaryData: [], branchGrandTotal: 0 };
  
  //   // Get unique categories and branches
  //   const categories = [...new Set(reportData.map((item) => item.category))];
  //   const branches = [...new Set(reportData.map((item) => item.branch))];
  
  //   // Initialize category data structure
  //   const dataMap = {};
  //   categories.forEach((category) => {
  //     dataMap[category] = {};
  //     branches.forEach((branch) => {
  //       dataMap[category][branch] = 0; // Default value
  //     });
  //   });
  
  //   // Populate the dataMap with actual values
  //   reportData.forEach((item) => {
  //     dataMap[item.category][item.branch] += item.netTotal;
  //   });
  
  //   // Construct tableData (categories as rows, branches as columns)
  //   const tableData = categories.map((category) => {
  //     let categoryTotal = 0;
  //     const row = { key: category, category };
  
  //     branches.forEach((branch) => {
  //       const value = dataMap[category][branch];
  //       row[branch] = value;
  //       categoryTotal += value;
  //     });
  
  //     row.categoryTotal = categoryTotal;
  //     return row;
  //   });
  
  //   // Calculate branch-wise totals
  //   const branchTotals = {};
  //   branches.forEach((branch) => {
  //     branchTotals[branch] = reportData
  //       .filter((item) => item.branch === branch)
  //       .reduce((sum, item) => sum + item.netTotal, 0);
  //   });
  
  //   // Create the summary data for branch-wise totals
  //   const summaryData = branches.map((branch) => ({
  //     key: branch,
  //     branch,
  //     branchTotal: branchTotals[branch],
  //   }));
  
  //   // Calculate overall grand total
  //   const branchGrandTotal = Object.values(branchTotals).reduce((sum, val) => sum + val, 0);
  
  //   // Add total row in summaryData
  //   summaryData.push({
  //     key: "total",
  //     branch: "Total",
  //     branchTotal: branchGrandTotal,
  //   });
  
  //   // Create final row for tableData (branch-wise totals)
  //   const lastRow = { key: "branchTotal", category: "Branch Totals" };
  //   let grandTotal = 0;
    
  //   branches.forEach((branch) => {
  //     lastRow[branch] = branchTotals[branch] || 0;
  //     grandTotal += branchTotals[branch] || 0;
  //   });
  
  //   lastRow.categoryTotal = grandTotal;
  //   tableData.push(lastRow); // Append the total row to tableData
  
  //   return { branches, categories, tableData, summaryData, branchGrandTotal };
  // }, [reportData]);
  
  

 const { branches, categories,tableData, summaryData, categoryGrandTotal } =
  useMemo(() => {
    // Extract unique branches and categories
    const branches = [...new Set(reportData?.map((item) => item.branch))];
    const categories = [...new Set(reportData?.map((item) => item.category))];

    // Preprocess reportData into a nested map
    const dataMap = reportData.reduce((acc, item) => {
      if (!acc[item.branch]) acc[item.branch] = {};
      if (!acc[item.branch][item.category]) acc[item.branch][item.category] = 0;
      acc[item.branch][item.category] += item.netTotal;
      return acc;
    }, {});

    // Generate tableData
    const tableData = branches?.map((branch) => {
      const row = { key: branch, branch };
      let branchTotal = 0;

      categories.forEach((category) => {
        const netTotal = dataMap[branch]?.[category] || 0;
        row[category] = netTotal;
        branchTotal += netTotal;
      });

      row.branchTotal = branchTotal;
      return row;
    });

    // Generate summaryData
    let summaryData = categories?.map((category) => {
      const categoryTotal = reportData
        .filter((item) => item.category === category)
        .reduce((sum, item) => sum + item.netTotal, 0);

      return { key: category, category, categoryTotal };
    });

    // Calculate grand totals
    const categoryGrandTotal = summaryData.reduce(
      (sum, row) => sum + row.categoryTotal,
      0
    );

    // const grandTotal = tableData.reduce(
    //   (sum, row) => sum + row.branchTotal,
    //   0
    // );
    const grandTotal = tableData
    .reduce((sum, row) => sum + parseFloat(row.branchTotal), 0)
    .toFixed(decimalpoints);


    // Add total row to summaryData
    const totalRow = {
      key: "total",
      category: "Total",
      categoryTotal: categoryGrandTotal,
    };
    summaryData.push(totalRow);

    // Create the last row for tableData representing category totals
    const lastRow = { key: "categoryTotal", branch: "Category Totals" };
    categories.forEach((category) => {
      const totalForCategory =
        summaryData?.find((s) => s.category === category)?.categoryTotal || 0;
      lastRow[category] = totalForCategory;
    });
    lastRow.branchTotal = grandTotal;

    // Include the last row in the table data
    tableData.push(lastRow);

    return { branches, categories, tableData, summaryData, categoryGrandTotal,decimalpoints };
  }, [reportData]);


  const modifiedList = Array.isArray(tableData)
    ? tableData?.filter((value) =>
        value.branch?.toLowerCase().includes(searchText?.toLowerCase())
      )
    : [];
 console.log(tableData,"taaaaaaaabledata");
 

  
    // const columns = [
    //   {
       
    //     title: "Category ",
    //     dataIndex: "category",
    //     key: "category",
    //     render: (text, record) =>
    //       record.key === "categoryTotal" ? <strong>{text}</strong> : text,
    //   },
    //   ...branches.map((branch) => ({
    //     title: branch,
    //     dataIndex: branch,
    //     key: branch,
    //     render: (value) =>
    //       value != null ? value.toFixed(decimalpoints) : 0,
    //   })),
    //   {
    //     title: "Category Total",
    //     dataIndex: "netTotal",
    //     key: "netTotal",
    //     render: (value, record) =>
    //       record.key === "categoryTotal" ? (
    //         <strong>{value}</strong>
    //       ) : value != null ? (
    //         value.toFixed(decimalpoints)
    //       ) : (
    //         0
    //       ),
    //   },
    // ];

const columns = [
    {
      title: "Branch",
      dataIndex: "branch",
      key: "branch",
      render: (text, record) =>
        record.key === "categoryTotal" ? <strong>{text}</strong> : text,
    },
    ...categories.map((category) => ({
      title: category,
      dataIndex: category,
      key: category,
      render: (value) =>
        value !== undefined ? value.toFixed(decimalpoints) : 0,
    })),
    {
      title: "Branch Total",
      dataIndex: "branchTotal",
      key: "branchTotal",
      render: (value, record) =>
        record.key === "categoryTotal" ? (
          <strong>{value}</strong>
        ) : value !== undefined ? (
          value.toFixed(decimalpoints)
        ) : (
          0
        ),
    },
  ];

  const summaryColumns = [
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "Total",
      dataIndex: "categoryTotal",
      key: "categoryTotal",
      render: (value) =>
        value !== undefined ? value.toFixed(decimalpoints) : 0,
    },
  ];
  
  function handleReset() {
    const today = dayjs(); // Get current date using dayjs
   
       setFromDate(today);
       setToDate(today);
    setSearchText("");
    setreportData([]);
    // modifiedList = [];
    //  summaryData = [];
  }
  const getActiveTabData = () => {
    let fieldMapping = {};

    const createfieldMapping = (columns) => {
      const mappings = {};
      columns.forEach((col) => {
        mappings[col.title] = col.dataIndex; // Map column title to its dataIndex
      });
      return mappings;
    };
    const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
    const currfmt = match ? match[0]?.length - 1 : 0;
    switch (activeTab) {
      case "1":
        fieldMapping = createfieldMapping(columns);
       // console.log("fieldMapping of first table:", fieldMapping);
        return { data: modifiedList, columns: columns,Rname:"Category Detailed  Report", fieldMapping,currfmt };
      case "2":
        fieldMapping = createfieldMapping(summaryColumns);
       // console.log("fieldMapping of second table:", fieldMapping);
        return { data: summaryData, columns: summaryColumns,Rname:"Category Summary Report", fieldMapping,currfmt };
      default:
        return { data: [], columns: [],currfmt };
    }
  };


  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };
  
  const paginationConfig = {
    pageSize: pageSize,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50", "100"],
    onShowSizeChange: (current, size) => setPageSize(size),
  };

  return (
    <div>
      <LoadingUtils loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Category Consolidated Reports</h4>
                <h6>Manage consolidated Category reports here</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <Link
                    onClick={() =>
                      exportMasterPDF(getActiveTabData)
                    }
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Excel")}
                >
                  <Link
                    onClick={() =>
                      exportMasterExcel(getActiveTabData)
                    }
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Print")}
                >
                  <Link
                    onClick={() =>
                      printMasterReport(getActiveTabData)
                    }
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Refresh")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    onClick={() => handleReportList()}
                  >
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Collapse")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top ">
                <div className="search-set">
                  <div className="search-input">
                    <Link to="#" className="btn btn-searchset">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-search"
                      >
                        <circle cx={11} cy={11} r={8} />
                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                      </svg>
                    </Link>
                    <div
                      id="DataTables_Table_0_filter"
                      className="dataTables_filter"
                    >
                      <label>
                        {" "}
                        <input
                          type="search"
                          className="form-control form-control-sm"
                          placeholder="Search"
                          aria-controls="DataTables_Table_0"
                          value={searchText}
                          onChange={handleSearch}
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-blocks">
                        <label>From Date</label>
                        <DatePicker
                          id="from-date"
                          placeholderText="From Date"
                          value={fromDate}
                          onChange={handleFromDateChange}
                          startDate={fromDate}
                          selectsStart
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-blocks">
                        <label>To Date</label>
                        <DatePicker
                          id="to-date"
                          placeholderText="To Date"
                          value={toDate}
                          onChange={handleToDateChange}
                          minDate={fromDate}
                          startDate={fromDate}
                          selectsEnd
                          disabled={!fromDate} // disable until from date is selected
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="input-blocks p-3 mt-3">
                    <Link
                      className="btn btn-filters rounded-2 "
                      onClick={handleReportList}
                    >
                      <i data-feather="search" className="feather-search" />{" "}
                      Search{" "}
                    </Link>
                  </div>
                  <div className="input-blocks mt-3">
                    <button
                      className="btn btn-reset  rounded-2 "
                      onClick={handleReset}
                    >
                      <i
                        data-feather="refresh-cw"
                        className="feather-refresh-cw"
                      />{" "}
                      Reset
                    </button>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <Tabs defaultActiveKey="1" onChange={handleTabChange}>
                  <TabPane tab="Detailed View" key="1">
                    <Table columns={columns} dataSource={tableData} pagination={paginationConfig} />
                  </TabPane>
                  <TabPane tab="Summary View" key="2">
                    <Table columns={summaryColumns} dataSource={summaryData} pagination={paginationConfig} />
                  </TabPane>
                </Tabs>
              </div>
               <div className="footerComment ml-3"> <b>* Please be informed that there will be a difference between the item-wise sales report and other sales reports if a bill-wise discount is applied.</b></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CategoryReport;